import { Bot, Filter, GitMerge } from 'lucide-react';

import type { ExposureBadge, ExposureBadgeState } from './schema-editor.types';

export const EXPOSURE_BADGES = [
  { key: 'segments', label: 'Segments', Icon: Filter },
  { key: 'mergeFields', label: 'Merge fields', Icon: GitMerge },
  { key: 'agentTools', label: 'Agentic tools', Icon: Bot },
] as const satisfies readonly ExposureBadge[];

export const EXPOSURE_STATE_TITLE = {
  off: 'off',
  on: 'on',
  unnamed: 'needs a display name',
} as const satisfies Record<ExposureBadgeState, string>;

/** An enabled surface still needs a display name before anything can use it. */
export function exposureBadgeState(enabled: boolean, named: boolean): ExposureBadgeState {
  if (!enabled) return 'off';
  return named ? 'on' : 'unnamed';
}
